import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var resetEditorPublishResults = createAction("".concat(actionTypePrefix, "/RESET_EDITOR_PUBLISH_RESULTS"), function (editorId) { return ({ editorId: editorId }); });
export var publishComment = createAction("".concat(actionTypePrefix, "/PUBLISH_COMMENT"), function (publisher) { return publisher; });
export var publishCommentSuccess = createAction("".concat(actionTypePrefix, "/PUBLISH_COMMENT_SUCCESS"), function (result) { return result; });
export var publishCommentFailure = createAction("".concat(actionTypePrefix, "/PUBLISH_COMMENT_FAILURE"), function (result) { return result; });
export var focusEditor = createAction("".concat(actionTypePrefix, "/FOCUS_EDITOR"), function (editorId) { return ({
    editorId: editorId,
}); });
export var focusEditorWithScroll = createAction("".concat(actionTypePrefix, "/FOCUS_EDITOR_WITH_SCROLL"), function (editorId, smoothScroll) { return ({
    editorId: editorId,
    smoothScroll: smoothScroll,
}); });
export var focusDone = createAction("".concat(actionTypePrefix, "/FOCUS_DONE"), function (editorId) { return ({
    editorId: editorId,
}); });
//# sourceMappingURL=actionCreators.js.map